import React, { useEffect } from 'react'

import DayPicker from 'modules/core/components/DayPicker'
import i18n from 'modules/core/lib/i18n'

import { Element } from 'modules/forms/lib/Element'
import { Answer } from 'modules/forms/lib/types'
import { F0DatePicker } from '@factorialco/f0-react'
import { DatePickerValue } from '@factorialco/f0-react/dist/experimental'
import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'

interface DateElementQuestionProps {
  element: Element
  onChange?: (answer: Answer) => void
  disabled?: boolean
}

/**
 * Editor component for DateElement
 */
const DateElementQuestion: React.FC<DateElementQuestionProps> = ({
  element,
  onChange,
  disabled,
}) => {
  const [value, setValue] = React.useState<string | undefined>(element.answer?.answer)

  useEffect(() => {
    setValue(element.answer?.answer)
  }, [element.id, element.answer?.answer])

  const handleOnChange = (pickerValue: DatePickerValue | undefined) => {
    const newValue = pickerValue?.value?.from
      ? (i18nDateToString(pickerValue.value.from, 'backend') ?? undefined)
      : undefined
    setValue(newValue)
    if (newValue !== undefined) onChange?.({ answer: newValue })
  }

  const toPickerValue = (s: string | undefined): DatePickerValue | undefined => {
    if (!s) return undefined
    const d = stringToDate(s, 'backend')
    if (!d.isValid()) return undefined
    return { granularity: 'day', value: { from: d.toDate(), to: d.toDate() } }
  }

  const hasAttemptedSubmit = false // TODO

  const getError = () => {
    if (hasAttemptedSubmit) {
      if (element.mandatory && !value) {
        return i18n.t('forms.render.answer_required')
      }
    }
    return undefined
  }

  return (
    <F0DatePicker
      label={element.label}
      required={element.mandatory}
      disabled={disabled}
      value={toPickerValue(value)}
      onChange={handleOnChange}
      error={getError()}
      clearable
    />
  )
}

export default DateElementQuestion
